/* eslint-disable no-shadow */
import Auction from '@/models/Auction';
import UserClient from '@/api/UserClient';

const vdpVersionPreferenceKey = 'vdp_3_web';

const initialState = {
  pandaAuction: {},
  vdpVersionPreference: undefined,
  hasFetchedVdpVersionPreference: false,
  reportAProblemContext: null,
};

export const state = {
  ...initialState,
};

const mutations = {
  setPandaAuction(state, payload) {
    state.pandaAuction = payload;
  },
  setVdpVersionPreference(state, payload) {
    state.vdpVersionPreference = payload;
  },
  changeHasFetchedVdpVersionPreference(state, payload) {
    state.hasFetchedVdpVersionPreference = payload;
  },
  setReportAProblemData(state, { options, dealerId }) {
    state.reportAProblemContext = { options, dealerId };
  },
  clearReportAProblemData(state) {
    state.reportAProblemContext = null;
  },
};

const actions = {
  updatePandaAuction({ commit, rootGetters }, { auction = {} }) {
    // should make an auction model
    commit('setPandaAuction', new Auction(auction, rootGetters.currentUser));
  },
  clearPandaAuction({ commit }) {
    commit('setPandaAuction', {});
    commit('clearReportAProblemData');
  },
  clearVdpVersionPreference({ commit }) {
    commit('setVdpVersionPreference', undefined);
    commit('changeHasFetchedVdpVersionPreference', false);
  },
  async getVdpVersionPreference({ rootState, commit, state }) {
    if (state.hasFetchedVdpVersionPreference) {
      return state.vdpVersionPreference;
    }
    const userClient = new UserClient(rootState.authorization.user);
    let vdpVersionPreference;
    try {
      const {
        data: {
          data: { [vdpVersionPreferenceKey]: result },
        },
      } = await userClient.getKeyValueStoreItem(vdpVersionPreferenceKey);
      vdpVersionPreference = result ? JSON.parse(result) : undefined;
    } finally {
      commit('setVdpVersionPreference', vdpVersionPreference ?? false);
      commit('changeHasFetchedVdpVersionPreference', true);
    }

    return vdpVersionPreference;
  },

  async toggleVdpVersionPreference(
    { rootState, commit, state },
    { forceTrue } = {},
  ) {
    const userClient = new UserClient(rootState.authorization.user);

    await userClient.putKeyValueStoreItem(
      vdpVersionPreferenceKey,
      JSON.stringify(forceTrue ? true : !state.vdpVersionPreference),
    );
    commit('setVdpVersionPreference', !state.vdpVersionPreference);
  },
};

const getters = {
  getPandaAuction: (state) => state.pandaAuction,
  useNewVdpPreference: (state) => state.vdpVersionPreference,
  reportAProblemContext: (state) => state.reportAProblemContext,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
